// extracted by mini-css-extract-plugin
export default {"container":"SlideCoverButton_container__XR1oK","button":"SlideCoverButton_button__XMQaB"};